import { updateOrder } from '../services/napi';

export function reorderContent(data, url) {
  return async (dispatch, getState) => {
    const { _id: projectId } = getState().project.currentProject;

    const filteredData = data.map((component, index) => {
      const obj = { _id: component._id, order: index };
      return obj;
    });

    try {
      const dataWithPath = { data: filteredData };
      await updateOrder(dataWithPath, projectId, url);
    } catch (error) {
      console.error(error);
    }
  };
}
